export const PAGE_FIX_CHANGE_TYPES = {
    word: 'w',
    element: 'e',
    attribute: 't',
} as const;
